<template>
  <material-card
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    :title="$t('views.demographics.demographics')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="pie_chart"
  >
    <v-card-text>
      <v-form v-model="valid" v-if="effectiveDate">
        <v-container fluid>
          <v-row>
            <v-col>
              <pbas-date-picker
                :value="effectiveDate"
                @update-date="effectiveDate = $event"
                :label="$t('views.demographics.select_a_date')"
                :rules="[$rules.required, $rules.firstRenewalDate]"
                :allowedDates="allowedDates"
                class="required"
              ></pbas-date-picker>
            </v-col>
            <v-col>
              <trans-select2
                v-model="selected"
                propertyName="insuranceCarrier"
                :items="insuranceCarriers"
                :label="$t('globals.insurance_carrier')"
                :rules="[$rules.required]"
                field="Name"
                itemValue="Id"
                transPropertyName="InsuranceCarrier"
                class="required"
              ></trans-select2>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <demographics-table
      :saving="saving"
      ref="table"
      v-if="url"
      @onerror="onTableError($event)"
      :url="url"
      @archive="archiveReport($event)"
      :insuranceCarrier="selected.insuranceCarrier"
      :date="effectiveDate"
      :identifier="selectedPlan.Id + '_demographicsReportTable'"
    ></demographics-table>
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import DemographicsTable from "../components/DemographicsTable";
import TransSelect2 from "../components/TransSelect2";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "demograpgics",
  components: {
    ErrorHandler,
    DemographicsTable,
    TransSelect2,
  },
  mixins: [planSetter],
  data() {
    return {
      saving: false,
      url: null,
      valid: false,
      selected: {
        insuranceCarrier: null,
      },
      insuranceCarriers: [],
      error: null,
      effectiveDate: null,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { planIdentity: "planIdentity" }),
  },
  watch: {
    effectiveDate: {
      handler(v) {
        if (v && this.selected.insuranceCarrier) {
          this.url =
            "plans/" +
            this.selectedPlan.Id +
            "/insuranceCarriers/" +
            this.selected.insuranceCarrier.Id +
            "/effectiveDate/" +
            v +
            "/demographics";
        }
      },
    },
    "selected.insuranceCarrier": {
      handler(v) {
        if (v && this.effectiveDate) {
          this.url =
            "plans/" +
            this.selectedPlan.Id +
            "/insuranceCarriers/" +
            v.Id +
            "/effectiveDate/" +
            this.effectiveDate +
            "/demographics";
        }
      },
    },
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getInsuranceCarriers",
      "newDemographicsReport",
    ]),
    async loadPlanData() {
      this.effectiveDate = this.$helpers.nowFormatted();
      try {
        this.insuranceCarriers = (await this.getInsuranceCarriers(
          this.selectedPlan.Id
        )).data.value;
      } catch (error) {
        this.error = error;
      }
    },
    allowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    onTableError(error) {
      this.error = error;
    },
    async archiveReport(items) {
      try {
        //console.log(items);
        this.saving = true;
        let payload = (payload = {
          Date: this.effectiveDate,
          InsuranceCarrierId: this.selected.insuranceCarrier.Id,
          MemberIds: items,
        });
        //console.log(payload)
        await this.newDemographicsReport({
          plan: this.selectedPlan.Id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        //this.$refs.table.getDataAsync();
        this.$refs.table.confirmArchiveReportDialog = false;
      } catch (error) {
        this.$emit("onerror", error);
      }
      this.saving = false;
    },
  },
};
</script>

<style></style>
